/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import styled from 'styled-components';
import ds from 'designsystem';
import { Column } from 'hedron';
import { BlogAuthor as BlogAuthorModel } from 'models';
import ANCHOR from 'common/consts/anchor';
import { underscoresToDashes } from 'common/methods/string';
import Bind from 'lodash-decorators/bind';
import { media } from 'common/responsive';
import Header4 from 'elements/Header4';
import Paragraph from 'elements/Paragraph';
import Image from './Image';

const Wrapper = styled.div`
    cursor: pointer;
    margin-bottom: ${ds.get('metrics.m')}
    ${media.tablet`
      display:flex;
      margin-bottom:0;
    `};
`;

const StyledHeader = styled(Header4)`
  margin: ${ds.get('metrics.xs')} 0;
  ${media.desktop`
    margin: 0;
  `};
`;

const StyledParagraph = styled(Paragraph)`
  margin-top:0;
`;

const StyledColumn = styled(Column)`
  margin-right:${ds.get('metrics.xl')};
`;

@inject('blogStore', 'windowStore', 'appStore')
@observer
@withRouter
export default class BlogAuthorBox extends Component {
  @Bind()
  filterByAuthor(author) {
    const {
      history,
      author: {
        codename,
      },
      appStore: {
        currentLanguage,
      },
    } = this.props;

    history.push({
      pathname: `${ANCHOR.BLOG[currentLanguage]}/${underscoresToDashes(codename)}`,
      state: {
        cameFromArticle: true,
        author,
      },
    });
  }

  render() {
    const {
      blogStore,
      author: {
        name,
        position,
        description,
        image,
        system,
      },
      windowStore,
    } = this.props;

    const author = blogStore.blogAuthors
      .find(filterAuthor => filterAuthor.system.codename === system.codename);

    const authorToFilter = {
      name: author.name,
      value: author.value,
      count: author.count,
    };

    return (
      <Wrapper onClick={() => this.filterByAuthor(authorToFilter)}>
        <Column fluid md={4} lg={3}>
          <Image url={windowStore.adjustImageSize(image)} />
        </Column>
        <StyledColumn fluid md={7} lg={8} mdShift={1}>
          <StyledHeader>
            {name}
          </StyledHeader>
          <StyledParagraph>
            {position}
          </StyledParagraph>
          <Paragraph>
            {description}
          </Paragraph>
        </StyledColumn>
      </Wrapper>
    );
  }
}

BlogAuthorBox.propTypes = {
  author: PropTypes.instanceOf(BlogAuthorModel).isRequired,
};



// WEBPACK FOOTER //
// ./src/pages/BlogArticle/BlogAuthor/index.jsx